import { gql } from 'graphql-request';

export const BUNDLER_COLLECTION_PRODUCT_FIELDS = gql`
    fragment BundlerCollectionProductFields on Product {
        title
        handle
        productType
        gender: metafield(namespace: "custom", key: "gender_multiselect") {
            value
        }
        metafield(key: "short_description", namespace: "product") {
            value
        }
        images(first: 15) {
            edges {
                node {
                    altText
                    height
                    width
                    transformedSrc
                }
            }
        }
        variants(first: 20) {
            edges {
                node {
                    id
                    availableForSale
                    quantityAvailable
                    priceV2 {
                        amount
                        currencyCode
                    }
                    compareAtPriceV2 {
                        amount
                    }
                    selectedOptions {
                        name
                        value
                    }
                    product {
                        handle
                        tags
                        gender: metafield(
                            namespace: "custom"
                            key: "gender_multiselect"
                        ) {
                            value
                        }
                        images(first: 15) {
                            edges {
                                node {
                                    transformedSrc
                                    width
                                    height
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
